import basePath from "../path";

export const teamMembersPath = `${basePath}/team`;

export default teamMembersPath;
